import { useTranslation } from 'react-i18next'

import { FieldRow, FieldViewValue } from '@/components/layout/field-row'
import { Chip } from '@/components/ui/chip'
import { Flex } from '@/components/ui/flex'

import { MAX_LOCKERS, OtherFormData } from './other-tab.constants'

interface LuxerLockersViewProps {
  values: OtherFormData
}

export const LuxerLockersView = ({ values }: LuxerLockersViewProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <FieldRow
      hint={t('organisation:places.other.luxer.description', { max: MAX_LOCKERS })}
      label={t('organisation:places.other.luxer.title')}
    >
      <FieldViewValue>
        {values.luxerIds.length ? (
          <Flex gap={8} wrap="wrap">
            {values.luxerIds.map((id) => (
              <Chip key={id} color="blue" label={id} size="small" variant="light" />
            ))}
          </Flex>
        ) : null}
      </FieldViewValue>
    </FieldRow>
  )
}
